/* eslint-disable @typescript-eslint/no-unused-vars */
import { LazyQueryExecFunction, OperationVariables } from '@apollo/client'
import { Collapse, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'

import { getTranslate } from '../../localization'
import { StructuredData } from '../../types/rateConnection'
import { RatePlanBrief } from '../../types/rateplan'
import { RoomTypeBrief } from '../../types/roomtype'
import ExpandableBoxRow from './ExpandableBoxRow'
import ExpandableBoxRowSkeleton from './ExpandableBoxRow.Skeleton'
import useStyles from './styles/ExpandableBox.styles'

interface ExpandableBoxProps {
  data: StructuredData
  depth: number
  getRoomTypes: LazyQueryExecFunction<
    {
      roomTypes: RoomTypeBrief[]
    },
    OperationVariables
  >
  getRatePlans: LazyQueryExecFunction<
    {
      ratePlans: RatePlanBrief[]
    },
    OperationVariables
  >
  loadingForRoomtypes?: boolean
  setSelectedAccommodationID?: React.Dispatch<React.SetStateAction<string>>
  exactAccommodationLayer?: boolean
  structuredData: StructuredData[]
  setStructuredData: React.Dispatch<React.SetStateAction<StructuredData[]>>
  providerCode: string
  disabled?: boolean
}

export default function ExpandableBox({
  data: initialData,
  depth,
  getRoomTypes,
  getRatePlans,
  loadingForRoomtypes,
  setSelectedAccommodationID,
  exactAccommodationLayer,
  structuredData,
  setStructuredData,
  providerCode,
  disabled
}: ExpandableBoxProps) {
  const classes = useStyles({ depth })
  const [data, setData] = useState(initialData)
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    setData(initialData)
  }, [initialData])

  return (
    <div className={classes.root}>
      <div
        className={[
          classes.expandableBoxRowContainer,
          disabled ? classes.expandableBoxRowContainerDisabled : ''
        ].join(' ')}>
        <ExpandableBoxRow
          data={data}
          depth={depth}
          expanded={expanded}
          setExpanded={setExpanded}
          getRoomTypes={getRoomTypes}
          getRatePlans={getRatePlans}
          setSelectedAccommodationID={setSelectedAccommodationID}
          structuredData={structuredData}
          setStructuredData={setStructuredData}
          providerCode={providerCode}
          disabled={disabled}
        />
      </div>
      <Collapse in={expanded} timeout={200} className={classes.layer}>
        {loadingForRoomtypes && exactAccommodationLayer ? (
          Array(2)
            .fill('')
            .map((_, i) => (
              <ExpandableBoxRowSkeleton key={i} depth={depth + 1} />
            ))
        ) : expanded &&
          depth < 4 &&
          data.children &&
          data.children.length > 0 ? (
          data.children.map((child: StructuredData, chIndex) => {
            return (
              <ExpandableBox
                key={child.id + chIndex}
                data={child}
                depth={depth + 1}
                getRoomTypes={getRoomTypes}
                getRatePlans={getRatePlans}
                loadingForRoomtypes={loadingForRoomtypes}
                setSelectedAccommodationID={setSelectedAccommodationID}
                exactAccommodationLayer={exactAccommodationLayer}
                structuredData={structuredData}
                setStructuredData={setStructuredData}
                providerCode={providerCode}
                disabled={disabled}
              />
            )
          })
        ) : (
          <Typography className={classes.middle}>
            {getTranslate('There Is No Data')}
          </Typography>
        )}
      </Collapse>
    </div>
  )
}
